import { connect } from "react-redux"
import LoginPopover from "./LoginPopover"

const mapStateToProps = (state) => ({
  customerSelections: state.customerSelections,
  myServices: state.myServices,
  userManageAccount: state.userManageAccount,
  userAccount: state.userAccount,
})

export default connect(mapStateToProps, null)(LoginPopover)
